// src/pages/EditFormPage.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

function EditFormPage() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Define the company_id and site_id
  const COMPANY_ID = 5411;
  const SITE_ID = null;

  useEffect(() => {
    // Fetch existing forms from the backend
    const fetchForms = async () => {
      try {
        const response = await axios.get(
          "https://formbuilderapi.getforsite.com/api/forms/",
          {
            params: {
              company_id: COMPANY_ID,
              site_id: SITE_ID,
            },
          },
        );

        // Assuming the response has a 'questionnaires' array
        setForms(response.data.questionnaires);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching forms:", err);
        setError("Failed to fetch forms. Please try again later.");
        setLoading(false);
      }
    };

    fetchForms();
  }, []);

  const handleEdit = (formId) => {
    // Navigate to the FormEditor with the selected form ID
    navigate(`/edit-form/${formId}`);
  };

  const handleCreateNew = () => {
    // Navigate to the Create Form page
    navigate("/create-form");
  };

  return (
    <Container maxWidth="md" sx={{ marginTop: 8 }}>
      <Paper elevation={3} sx={{ padding: 4 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Typography variant="h5" component="h2" gutterBottom>
              Edit an Existing Form
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleCreateNew}
              sx={{
                color: "black",
                backgroundColor: "#ffd902",
                borderRadius: "20px",
              }}
            >
              Create New Form
            </Button>
          </Grid>
        </Grid>

        {loading ? (
          <Grid container justifyContent="center" sx={{ marginTop: 4 }}>
            <CircularProgress />
          </Grid>
        ) : error ? (
          <Alert severity="error" sx={{ marginTop: 4 }}>
            {error}
          </Alert>
        ) : forms.length === 0 ? (
          <Alert severity="info" sx={{ marginTop: 4 }}>
            No forms available to edit.
          </Alert>
        ) : (
          <List>
            {forms.map((form) => (
              <ListItem key={form.id} divider>
                <ListItemText
                  primary={form.name}
                  secondary={`Form ID: ${form.id}`}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={() => handleEdit(form.id)}
                  >
                    <EditIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Container>
  );
}

export default EditFormPage;
